var BufferListChannelView = require('bufferlistchannelview');
var BufferListConversationView = require('bufferlistconversationview');
var BufferListServerLogView = require('bufferlistserverlogview');
var ChannelList = require('channellist');


var BufferListConnectionView = Backbone.View.extend({
    tagName: 'li',
    className: 'connection',
    initialize: function (options) {
        this.model.bind('remove', this.remove, this);
        this.buffers = {};
        this.parent = options.parent;
    },
    events: {
        'buttonClick button.join': 'clickJoin',
        'buttonClick p.archiveToggle button': 'clickArchiveToggle',
        'buttonClick p.collapseToggle button': 'clickCollapseToggle',
        'buttonClick p.spamWarning button': 'clickSpamWarning',
    },
    clickSpamWarning: function (e) {
        this.model.trigger('deletePMConfirm');
        return false;
    },
    clickJoin: function (e) {
        this.model.trigger('joinPrompt');
        return false;
    },
    clickArchiveToggle: function (e) {
        e.preventDefault();
        this.toggleArchives();
    },
    clickCollapseToggle: function (e) {
        e.preventDefault();
        this.model.toggleCollapsed();
    },
    renderServerLog: function () {
        var serverLog = new BufferListServerLogView({
            el: this.heading,
            model: this.model.serverLog
        });
        this.renderBufferView(serverLog);
        
        return this;
    },
    hideCollapseDelayed: function () {
        this.$el.off('mouseleave mouseenter');
        clearTimeout(this.hideCollapseDelayedTimer);
        this.$el.one('mouseleave', _.bind(function () {
            this.hideCollapseDelayedTimer = setTimeout(_.bind(function () {
                this.$el.removeClass('expanded');
                this.$el.off('mouseleave mouseenter');
            }, this), 2000);
            this.$el.one('mouseenter', _.bind(function () {
                this.hideCollapseDelayed();
            }, this));
        }, this));
    },
    renderCollapsed: function (initial, labChange) {
        var collapsed = this.model.isCollapsed();
        if (!initial && !labChange && !collapsed) {
            if (this.$('.collapseToggle').css('visibility') === 'visible') {
                this.$el.addClass('expanded');
                this.hideCollapseDelayed();
            }
        }
        this.$el.toggleClass('collapsed', collapsed);
        this.$('.collapseToggle button').attr('aria-expanded', String(!collapsed))
            .html(collapsed ? '<i class="fa fa-plus-square-o"></i>Expand' : '<i class="fa fa-minus-square-o"></i>Collapse');
    },
    renderCollapsedUnread: function () {
        if (!this.model.isCollapsed()) {
            $(this.el).removeClass('totalUnread');
        } else {
            $(this.el).toggleClass('totalUnread', !!this.model.buffers.any(function (b) {
                return b.isTrackingUnread() && b.hasUnseen();
            }));
        }
    },

    renderCollapsedHighlights: function () {
        var count = 0;
        this.model.session.unseenBuffers.each(function (buffer) {
            if (!buffer.isServerLog() && buffer.connection.equals(this.model)) {
                count += buffer.unseenHighlightCount();
            }
        }, this);

        if (count) {
            this.$('.totalBadge').text(count);
            $(this.el).addClass('activeTotalBadge');
        } else {
            this.$('.totalBadge').text('');
            $(this.el).removeClass('activeTotalBadge');
        }
        
        return this;
    },
    renderSSL: function () {
        this.$el.toggleClass('ssl', this.model.isSSL());
        this.$el.toggleClass('ssl_verify_error', this.model.isSSLVerifyError());
    },
    renderTwitch: function () {
        this.$el.toggleClass('twitch', this.model.isTwitch());
    },
    renderSlack: function () {
        this.$el.toggleClass('slack', this.model.isSlack());
        this.$el.toggleClass('slack--oauth', this.model.isSlackOAuth());
    },
    getTemplate: function () {
        if (!BufferListConnectionView._structure) {
            BufferListConnectionView._structure = $($('#tpl-connection-lists').html());
        }
        return BufferListConnectionView._structure.clone();
    },
    render: function () {
        this.$el.append(this.getTemplate().children());
        this.heading = this.$('h2.buffer');

        this.renderSSL();
        this.model.bind('change:ssl', this.renderSSL, this);
        this.renderTwitch();
        this.renderSlack();
        this.model.bind('change:ircserver', this.renderSlack, this);
        this.model.bind('change:hostname', this.renderSlack, this);
        this.model.bind('change:hostname', this.renderTwitch, this);


        this.renderCollapsed(true);
        this.renderCollapsedUnread();
        this.renderCollapsedHighlights();
        this.listenTo(this.model.buffers, 'unseenChange', this.renderCollapsedUnread);
        this.listenTo(this.model.buffers, 'unseenHighlightChange', this.renderCollapsedHighlights);
        this.listenTo(this.model.serverLog, 'change:archived', function () {
            this.renderCollapsed();
            this.renderCollapsedUnread();
        });
        this.listenTo(this.model.session, 'prefChange:labs', function () {
            this.renderCollapsed(false, true);
        });
        
        // Buffer lists
        this.channelList = this.$('ul.channels');
        this.inactiveChannelList = this.$('ul.inactiveChannels');
        this.conversationList = this.$('ul.conversations');
        this.archivedChannelList = this.$('ul.archivedChannels');
        this.archivedConversationList = this.$('ul.archivedConversations');
        
        this.renderPasswordedWarning();
        
        this.renderServerLog();
        
        this.renderConnectionStatus();
        this.model.bind('change:status change:fail_info', this.renderConnectionStatus, this);
        
        var renderMap = {
            'pinnedBuffers': this.parent.pinnedBufferList,
            'activeChannels': this.channelList,
            'inactiveChannels': this.inactiveChannelList,
            'activeConversations': this.conversationList,
            'archivedChannels': this.archivedChannelList,
            'archivedConversations': this.archivedConversationList
        };
        _.each(renderMap, function (list, collectionName) {
            var collection = this.model.buffers[collectionName];
            var handler = this.renderCollectionBuffers(list, collection);
            collection.bind('add', handler);
        }, this);
        if (this.model.buffers.hasChildren() || this.model.buffers.hasArchivedBuffers()) {
            this.collapseJoinLink();
        } else {
            this.expandJoinLink();
        }
        this.renderSpamWarning();

        // This connection has archives
        if (this.model.buffers.hasArchivedBuffers()) {
            this.showArchives();
        }

        this.model.on('archivesFetched', this.renderArchives, this);
        this.model.on('archiveFetchFailed', this.closeArchives, this);
        this.model.buffers.bind('change:archived', this.renderBufferArchived, this);
        this.model.buffers.bind('selectedChange', this.renderBufferSelected, this);
        this.model.buffers.bind('remove', this.removeBuffer, this);
        this.model.buffers.bind('unseenChange', this.renderSpamWarning, this);
        
        return this;
    },
    renderArchives: function () {
        var renderMap = {
            'archivedChannels': this.archivedChannelList,
            'archivedConversations': this.archivedConversationList
        };
        _.each(renderMap, function (list, collectionName) {
            var collection = this.model.buffers[collectionName];
            this.renderCollectionBuffers(list, collection);
        }, this);
    },
    renderCollectionBuffers: function (list, collection) {
        var handler = _.bind(function (buffer) {
            if (buffer.connection.equals(this.model)) {
                var renderer = buffer.isChannel() ? this.renderChannel : this.renderConversation;
                if (!buffer.isArchived() || !this.model.isFetchingArchives()) {
                    renderer.call(this, buffer, collection, list);
                }
            }
        }, this);
        collection.each(handler);
        return handler;
    },
    renderBufferSelected: function (buffer) {
        this.$el.toggleClass('childSelected', buffer.isSelected());
        if (!buffer.isServerLog() && buffer.isSelected() && buffer.isArchived()) {
            this.openArchives();
        }
        if (buffer.isSelected()) {
            if (buffer.connection.isCollapsed()) {
                this.buffers[buffer.connection.serverLog.bid()].scrollToView();
            } else {
                this.buffers[buffer.bid()].scrollToView();
            }
        }
    },
    renderBufferArchived: function (buffer) {
        if (this.model.buffers.hasArchivedBuffers()) {
            this.showArchives();
        }
        this.conversationList.toggleClass('hide', !this.model.buffers.hasActiveConversations());
        this.renderSpamWarning();
        if (!buffer.isServerLog()) {
            var hasArchives = this.model.buffers.hasArchivedBuffers();
            if (buffer.wasArchived()) {
                if (!hasArchives) {
                    this.hideArchives();
                } else {
                    this.closeArchives();
                }
            } else {
                if (hasArchives) {
                    this.showArchives();
                }
            }
        }
    },
    renderBufferView: function (bufferView) {
        bufferView.render();
        bufferView.bubble('scrollTo', this);
        if (this.buffers[bufferView.model.bid()]) {
            this.buffers[bufferView.model.bid()].remove();
        }
        this.buffers[bufferView.model.bid()] = bufferView;
    },
    renderChildView: function (childView, collection, list) {
        this.renderBufferView(childView);
        
        // This connection has children
        this.collapseJoinLink();
        var buffer = childView.model;
        
        // Insert in the correct position
        var existing = list.children();
        var index = collection.indexOf(buffer);
        var el = childView.el;
        if (index == existing.length) {
            list.append(el);
        } else {
            existing.eq(index).before(el);
        }

        // These can either be conversations of slack mpdms (channels)
        this.conversationList.toggleClass('hide', !this.model.buffers.hasActiveConversations());
    },
    renderChannel: function (channel, collection, list) {
        var channelView = new BufferListChannelView({
            model: channel
        });
        this.renderChildView(channelView, collection, list);
    },
    renderConversation: function (conversation, collection, list) {
        var conversationView = new BufferListConversationView({
            model: conversation
        });
        this.renderChildView(conversationView, collection, list);
    },
    removeBuffer: function (buffer, options) {
        // Just removed the last buffer
        if (!this.model.buffers.hasChildren() && !this.model.buffers.hasArchivedBuffers()) {
            this.expandJoinLink();
        }
        // Removed the last archived buffer
        if (buffer.isArchived() && !this.model.hasArchivedBuffers()) {
            this.hideArchives();
        }
        this.conversationList.toggleClass('hide', !this.model.buffers.hasActiveConversations());
        this.renderSpamWarning();
        delete this.buffers[buffer.bid()];
    },
    hideArchives: function () {
        this.$('p.archiveToggle').removeClass('show');
        this.closeArchives();
        this.trigger('toggleArchives');
    },
    showArchives: function () {
        this.$('p.archiveToggle').addClass('show');
        this.trigger('toggleArchives');
    },
    openArchives: function () {
        if (!this.model.isFetchingArchives() && this.model.hasDeferredArchives()) {
            this.loadArchives();
        }
        this.archivesOpen = true;
        this.$el.addClass('openArchives');
        this.trigger('toggleArchives');
        this.$('p.archiveToggle button').attr('aria-expanded', 'true');
    },
    closeArchives: function () {
        this.archivesOpen = false;
        this.$el.removeClass('openArchives');
        this.trigger('toggleArchives');
        this.$('p.archiveToggle button').attr('aria-expanded', 'false');
    },
    toggleArchives: function () {
        if (this.archivesOpen) {
            this.closeArchives();
        } else {
            this.openArchives();
        }
    },
    loadArchives: function () {
        this.$el.addClass('loadingArchives');
        this.model.fetchArchives(_.bind(function (response) {
            this.$el.removeClass('loadingArchives');
            this.trigger('toggleArchives');
        }, this));
    },
    renderPasswordedWarning: function () {
        this.$('p.passwordedWarning').remove();
        if (this.model.get('server_pass') !== '') {
            var warningContents = $('<span>').text("Your subscription plan doesn't allow passworded connections.");
            var upgradeLink = $('<a>').attr('href', '/?/upgrade').text('Upgrade your account');
            var passwordedWarning = $('<p class="passwordedWarning">');
            passwordedWarning.append(warningContents);
            passwordedWarning.append(upgradeLink);
            this.heading.after(passwordedWarning);
        }
    },
    expandJoinLink: function () {
        this.$('p.join').removeClass('hide');
    },
    collapseJoinLink: function () {
        this.$('p.join').addClass('hide');
    },
    renderSpamWarning: function () {
        this.$('p.spamWarning').toggleClass('show', this.model.hasSpam());
    },
    renderConnectionStatus: function () {
        this.$el.toggleClass('disconnected', this.model.isDisconnected());
        this.$el.toggleClass('connected', !this.model.isDisconnected());
        this.$el.toggleClass('loading', this.model.isConnecting());
        this.$el.toggleClass('badRetry', this.model.badRetry());
        this.$el.toggleClass('failed', this.model.isFailed());
        this.heading.toggleClass('loading', this.model.isConnecting());
        this.heading.toggleClass('badRetry', this.model.badRetry());
        this.heading.toggleClass('failed', this.model.isFailed());
        this.renderSSL();
    }
});


module.exports = BufferListConnectionView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/bufferlistconnectionview.js
// module id = Zj5c
// module chunks = 1